import type { FC, ReactNode } from 'react'
import { cn } from '@/helpers/utils'

interface ListHeaderProps {
	className?: string
	title: ReactNode
	startSlot?: ReactNode
	endSlot?: ReactNode
	size?: 'sm' | 'md'
}

export const ListHeader: FC<ListHeaderProps> = ({
	className,
	title,
	size = 'md',
	startSlot,
	endSlot
}) => {
	return (
		<div
			className={cn(
				'flex items-center justify-between gap-4 border-neutral-200 border-b px-6',
				size === 'sm' ? 'h-16' : 'h-20',
				className
			)}
		>
			<div className='flex items-center gap-2'>
				<h2
					className={cn(
						'font-medium text-neutral-900',
						size === 'sm' ? 'text-base' : 'text-xl'
					)}
				>
					{title}
				</h2>
				{startSlot}
			</div>

			{endSlot}
		</div>
	)
}

ListHeader.displayName = 'ListHeader'
